module.exports = __webpack_public_path__ + "static/media/data3.4b9729c8.jpg";